/* eslint-disable react/destructuring-assignment */
import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IElement} from '../../../../incase-domain/elements';
import ElementsDesktop from './ElementsDesktop';
import ElementsMobile from './ElementsMobile';

interface ElementsMobileProps {
    slideId: string;
    elements: IElement[];
    onOptions: (id: string, silent?: boolean) => void;
    device: DeviceType.MOBILE;
}

interface ElementsDesktopProps {
    slideSize: {width: number; height: number};
    slideId: string;
    elements: IElement[];
    cellWidth: number;
    cellHeight: number;
    onOptions?: (id: string, silent?: boolean) => void;
    device: DeviceType.DESKTOP;
}

function Elements(props: ElementsMobileProps | ElementsDesktopProps): ReactElement {
    if (props.device === DeviceType.MOBILE) {
        return <ElementsMobile slideId={props.slideId} elements={props.elements} onOptions={props.onOptions} />;
    }

    return (
        <ElementsDesktop
            slideSize={props.slideSize}
            slideId={props.slideId}
            elements={props.elements}
            cellWidth={props.cellWidth}
            cellHeight={props.cellHeight}
            onOptions={props.onOptions}
        />
    );
}

export default Elements;
